import { gql } from '@apollo/client'

export const CHART2_QUERY = gql`
  query processingsFinishQuote(
    $groupBy: ProcessingsFinishQuoteGroupBy
    $filter: ProcessingsFinishQuoteFilter
    $target: Boolean
    $intern: Boolean
    $extern: Boolean
    $allAgents: Boolean
    $min: Int
    $max: Int
  ) {
    processingsFinishQuote(
      groupBy: $groupBy
      filter: $filter
      target: $target
      intern: $intern
      extern: $extern
      allAgents: $allAgents
      min: $min
      max: $max
    ) {
      series {
        color
        title
        average
        serie {
          name
          count
        }
      }
    }
  }
`
